export default [
    {
        path: '/promote',
        component: () => import('@/views/promote')
    },
    {
        path: '/promote/add',
        component: () => import('@/views/promote/add')
    },
    {
        path: '/promote/:id',
        props: (route) => ({
            id:  Number(route.params.id)
        }),
        component: () => import('@/views/promote/detail')
    },
    {
        path: '/promote/:id/edit',
        props: (route) => ({
            id:  Number(route.params.id)
        }),
        component: () => import('@/views/promote/edit')
    },
]